import Vue from 'vue'

Vue.filter('rtlTextAlign', value => {
  return value ? 'text-xs-left' : 'text-xs-right'
})
